import { UntypedFormGroup } from "@angular/forms";

export const countryCodeValidator = (form: UntypedFormGroup) => {
	if (!form.value) {
		return null;
	}
	const address = form.value.address;
	if (address && !address.countryCode) {
		return { noCountryCode: true };
	}
	return null;
};
